module.exports = __webpack_public_path__ + "static/img/w_05.439f2701.jpg";